import { Box } from '@mui/material';

import { zIndexes } from '@/styles/zIndexes';

interface DebugAnnotationBoxProps {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function DebugAnnotationBox({
  left,
  top,
  width,
  height,
}: DebugAnnotationBoxProps) {
  return (
    <Box
      sx={{
        position: 'absolute',
        left: left + 'px',
        width: width + 'px',
        top: top + 'px',
        height: height + 'px',
        border: '1px solid red',
        pointerEvents: 'none',
        zIndex: zIndexes.HIGHLIGHT - 1,
      }}
    />
  );
}
